// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";

const detectionOptions = {
  order: [
    "path",
    "cookie",
    "navigator",
    "localStorage",
    "subdomain",
    "queryString",
    "htmlTag"
  ],
  lookupFromPathIndex: 0
};

i18n
  .use(
    resourcesToBackend((language, namespace) => {
      return import(`./locales/${language}/${namespace}.json`);
    })
  )
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: detectionOptions,
    debug: true,
    fallbackLng: "es",
    supportedLngs: ["es", "en", "ro"],
    interpolation: {
      escapeValue: false
    },
    defaultNS: "translation",
    // ns: ["translation", "menuTrazability"]
  });

export default i18n;
